// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"App_mainWrapper__1e04V","confirmModal":"App_confirmModal__t1HQs"};